import React, { useEffect, useRef, useState } from 'react';
import {
	Box,
	Paper,
	Typography,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TableFooter,
	Button,
	Stack,
	Grid2,
} from "@mui/material";
import { Iconify } from "../Minimal/src/components/iconify";
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import { useParams } from 'react-router-dom';
import { API_URL, BASE_URL } from '../Config';
import config from "../common/Config";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import printPurchaseOrderInvoice from './generateSummaryPDF_dds';
import PurchaseOrderInvoice from "./PrintPurchaseOrderInvoice";	
const PurchaseViewPrint = (props) => {
	const { orderId } = useParams();

	const [productData, setProductData] = useState([]);
	const [shopDetails, setShopDetails] = useState([]);
	const [commonData, setCommonData] = useState([]);
	const [totalVal, setTotalVal] = useState({
		grandTotal: 0,
		grandTotalVat: 0,
	});
	const [totalzeroGoods, setTotalzeroGoods] = useState(0);
	const [totalstd, setTotalstd] = useState(0);

	const accessToken = localStorage.getItem('accessToken');
	const company_tax_type = localStorage.getItem("company_tax_type");
	const currencySymbol = localStorage.getItem("currencySymbol");

	const formatNumber = (num) => {
		return parseFloat(num).toFixed(2);
	};

	const isMeatsCategory = (item) => {
		if (!item) return false;
		const cat = (item.category || item.categorie_name || "").toString().trim();
		return cat === "MEATS" || cat === "Meats" || cat === "meats";
	};

	const formatQuantityDecimal = (val) => {
		if (val === undefined || val === null || val === '') return '0';
		const n = parseFloat(val);
		if (Number.isNaN(n)) return String(val);
		return Number.isInteger(n) ? String(n) : String(Number(n.toFixed(4)));
	};

	const formatQuantityForDisplay = (item, quantity) => {
		return isMeatsCategory(item) ? formatQuantityDecimal(quantity) : String(parseInt(quantity, 10) || 0);
	};

	const fetchProductInfo = async () => {
		const formData = new FormData();
		formData.append('id', orderId);
		const apiUrl = `${API_URL}/purchases/getpurches_items`;
		try {
			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to fetch Not Order Report');
			}
			const data = await response.json();
			setCommonData(data.commonData[0]);
			setShopDetails(data.shop_details);
			setProductData(data.purchase);


			const grandTotal = data.purchase.reduce((acc, item) => {
				const pdtVat = (parseFloat(item.unit_cost) * parseFloat(item.quantity)) * parseFloat(item.rate) / 100;
				const stotal = parseFloat(item.unit_cost) * parseFloat(item.quantity);
				const pdtTotal = pdtVat + stotal;
				return acc + pdtTotal;
			}, 0);
			const grandTotalVat = data.purchase.reduce((acc, item) => {
				const pdtVat = (parseFloat(item.unit_cost) * parseFloat(item.quantity)) * parseFloat(item.rate) / 100;
				return acc + pdtVat;
			}, 0);

			const totalstd = data.purchase
				.filter(item => parseFloat(item.rate) !== 0 && item.rate != '0.0000')
				.reduce((sum, item) => sum + (parseFloat(item.unit_cost) * parseFloat(item.quantity)), 0);

			const totalzeroGoods = data.purchase
				.filter(item => parseFloat(item.rate) === 0 || item.rate == '0.0000')
				.reduce((sum, item) => sum + (parseFloat(item.unit_cost) * parseFloat(item.quantity)), 0);

			setTotalstd(formatNumber(totalstd));
			setTotalzeroGoods(formatNumber(totalzeroGoods));

			setTotalVal({ grandTotal: formatNumber(grandTotal), grandTotalVat: formatNumber(grandTotalVat) });


		} catch (error) {
		}
	};

	useEffect(() => {

		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		fetchProductInfo();
	}, [accessToken]);

	const handleGenerateDeliveryNotePDF = (e, orderId) => {
		printPurchaseOrderInvoice(orderId, 'GRN');
	}

	const handleGeneratePDF = (e, orderId) => {
		PurchaseOrderInvoice(orderId, 'GRN');
	  };

	const generatePDF = () => {
		const doc = new jsPDF();

		// Header
		const header = [
			[`${shopDetails.shop_name}`, `PLEASE PHONE THE`],
			[`${shopDetails.address}`, `OFFICE TO PAY BY`],
			[`TEL : ${shopDetails.phone}`, `CREDIT/DEBIT CARD`],
			[`VAT NO : ${shopDetails.vat_no}`, `Bank A/C: ${shopDetails.bank_ac}`],
			[`COMPANY REG NO: ${shopDetails.company_reg_no}`, `Sort Code: ${shopDetails.sort_code}`],
		];

		// Define columns for autoTable
		const columns = [
			{ title: 'Description', dataKey: 'description' },
			{ title: 'Quantity', dataKey: 'quantity' },
			{ title: 'Type', dataKey: 'type' },
			// { title: 'Unit Cost', dataKey: 'unit_cost' },
			// { title: 'Tax', dataKey: 'tax' },
			// { title: 'Subtotal', dataKey: 'subtotal' },
		];

		// Prepare data for the table
		let qty = 0;
		const tableData = productData.map(item => {
			qty += parseFloat(item.quantity) || 0;
			let type;

			if (item.type === '1') {
				type = 'Pic';
			} else {
				type = 'Box';
			}

			return {
				description: `${item.product_code} - ${item.product_name} - ${item.size}`,
				quantity: formatQuantityForDisplay(item, item.quantity),
				type: type,
				// unit_cost: `£ ${formatNumber(item.unit_cost)}`, // Uncomment if needed
				// tax: `£ ${formatNumber(item.tax)}`, // Uncomment if needed
				// subtotal: `£ ${formatNumber(item.total)}` // Uncomment if needed
			};
		});

		// Add header to the document
		doc.autoTable({
			head: header,
			startY: 10,
			headStyles: { fontSize: 10 },
			margin: { top: 20 },
			showHead: 'firstPage',
		});

		// Add table body
		const itemsPerPage = 25;
		const totalPages = Math.ceil(tableData.length / itemsPerPage);

		for (let i = 0; i < totalPages; i++) {
			const startIndex = i * itemsPerPage;
			const endIndex = startIndex + itemsPerPage;
			const pageData = tableData.slice(startIndex, endIndex);

			if (i > 0) {
				doc.addPage();
			}

			doc.autoTable({
				columns: columns,
				body: pageData,
				startY: doc.previousAutoTable.finalY + 10 || 20,
				styles: { fontSize: 10 },
			});

			// Add footer only on the last page
			if (i === totalPages - 1) {
				const endY = doc.previousAutoTable.finalY;
				doc.autoTable({
					startY: endY + 10,
					body: [[`Total :  ${formatQuantityDecimal(qty)}`]],
					styles: { fontSize: 10, halign: 'right' },
				});
			}
		}
		// Save the PDF
		doc.save(`invoice_${commonData.supplierId}.pdf`);
	};
	let status = '';
	if (commonData.status === 'Draft') {
		status = 'Order';
	} else if (commonData.status === 'Close') {
		status = 'Received';
	} else {
		status = ''; // default or other statuses
	}
	return (
		<>
			<Box sx={{ backgroundColor: "#f5f7fa", minHeight: "calc(100vh - 42px)", p: 1.5 }}>
				<Paper
					elevation={0}
					sx={{
						borderRadius: 2,
						border: "1px solid rgba(145, 158, 171, 0.16)",
						overflow: "hidden",
						backgroundColor: "#fff",
					}}
				>
					<Box sx={{ p: 2 }}>
						<Grid2 container spacing={3}>
							<Grid2 size={{ xs: 12, md: 3}}>
								<Box>
									<Typography variant="h6" sx={{ fontWeight: 600, color: "#212b36", fontSize: "0.9rem" }}>
										{commonData.name || ""}
									</Typography>
									{commonData.note && (
										<Typography variant="body2" sx={{ mb: 0.5, color: "#637381", fontSize: "0.875rem" }}>
											{commonData.note}
										</Typography>
									)}
									{commonData.phone && (
										<Typography variant="body2" sx={{ mb: 0.5, color: "#637381", fontSize: "0.875rem" }}>
											Tel : {commonData.phone}
										</Typography>
									)}
									{commonData.email && (
										<Typography variant="body2" sx={{ mb: 0.5, color: "#637381", fontSize: "0.875rem" }}>
											Email : {commonData.email}
										</Typography>
									)}
									{commonData.vat_no && (
										<Typography variant="body2" sx={{ mb: 0.5, color: "#637381", fontSize: "0.875rem" }}>
											{company_tax_type} : {commonData.vat_no}
										</Typography>
									)}
								</Box>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 4}}>
								<Box>
									<Typography sx={{ fontWeight: 600, color: "#212b36", fontSize: "0.9rem" }}>
										{shopDetails.shop_name || ""}
									</Typography>
									{shopDetails.address && (
										<Typography sx={{ color: "#637381", fontSize: "0.825rem" }}>
											{shopDetails.address}
										</Typography>
									)}
								</Box>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 3}}>
								<Box>
									<Typography sx={{ fontWeight: 600, color: "#212b36", fontSize: "0.9rem" }}>
										{commonData.reference_no && commonData.reference_no.toUpperCase().startsWith('PO')
											? `PO No : ${commonData.reference_no}`
											: `GRN No : ${commonData.reference_no}`}
									</Typography>
									{commonData.date && (
										<Typography variant="body2" sx={{ color: "#637381", fontSize: "0.825rem" }}>
											Date : {commonData.date}
										</Typography>
									)}
									{commonData.invoice_number && (
										<Typography variant="body2" sx={{ color: "#637381", fontSize: "0.825rem" }}>
											Invoice No : {commonData.invoice_number}
										</Typography>
									)}
									{commonData.reference_number && (
										<Typography variant="body2" sx={{ color: "#637381", fontSize: "0.825rem" }}>
											Reference : {commonData.reference_number}
										</Typography>
									)}
								</Box>
							</Grid2>
							<Grid2 size={{ xs: 12, md: 2 }}>
								<Box sx={{ display: "flex", justifyContent: {xs: "center", md: "flex-end"}, gap: 1 }}>
									<Button 
									variant="contained" 
									className="button-variant-contained"
								    onClick={(e) => handleGenerateDeliveryNotePDF(e, orderId)}
									>
										Qty Print
									</Button>
									<Button
										variant="contained"
										
										className="button-variant-contained"
										onClick={(e) => handleGeneratePDF(e, orderId)}
										
										startIcon={<Iconify icon="eva:printer-outline" width={18} />}
									>
										Print
									</Button>
								</Box>
							</Grid2>
						</Grid2>
					</Box>
					<TableContainer>
						<Table
							size="medium"
							className="table-cell-border"
							sx={{ tableLayout: "fixed" }}
						>
							<TableHead>
								<TableRow className="table-cell-header">
									<TableCell
										sx={{
											width: "40%",
										}}
									>
										Code - Name 
									</TableCell>
									<TableCell
										sx={{
											width: "10%",
											textAlign: "center",
										}}
									>
										Quantity
									</TableCell>
									<TableCell
										sx={{
											width: "10%",
											textAlign: "center",
										}}
									>
										Type
									</TableCell>
									<TableCell
										sx={{
											width: "10%",
											textAlign: "right",
										}}
									>
										Unit Cost
									</TableCell>
									<TableCell
										sx={{
											width: "10%",
											textAlign: "right",
										}}
									>
										{company_tax_type}
									</TableCell>
									<TableCell
										sx={{
											width: "10%",
											textAlign: "right",
										}}
									>
										Subtotal
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{productData.length === 0 ? (
									<TableRow>
										<TableCell colSpan={6} sx={{ textAlign: "center", py: 3, color: "#637381" }}>
											No products available
										</TableCell>
									</TableRow>
								) : (
									productData.map((row, index) => {
										const pdtVat = (parseFloat(row.unit_cost) * parseFloat(row.quantity)) * parseFloat(row.rate) / 100;
										const stotal = parseFloat(row.unit_cost) * parseFloat(row.quantity);
										const pdtTotal = pdtVat + stotal;

										return (
											<TableRow
												key={index}
												sx={{
													"&:hover": {
														backgroundColor: "rgba(145, 158, 171, 0.08)",
													},
													'& .MuiTableCell-root': {
														fontSize: "0.75rem",
														color: "#212b36",
														py: 1.2,
													}
												}}
											>
												<TableCell

												>
													{row.product_code} - {row.product_name}
												</TableCell>
												<TableCell
													sx={{
														textAlign: "center",
													}}
												>
													{formatQuantityForDisplay(row, row.quantity)}
												</TableCell>
												<TableCell
													sx={{
														textAlign: "center",
													}}
												>
													{row.type === '1' ? 'Box' : 'Piece'}
												</TableCell>
												<TableCell
													sx={{

														textAlign: "right",
														fontWeight: 500,
													}}
												>
													{row.unit_cost ? `${currencySymbol} ${formatNumber(row.unit_cost)}` : `${currencySymbol} 0.00`}
												</TableCell>
												<TableCell
													sx={{

														textAlign: "right",
														fontWeight: 500,
													}}
												>
													{pdtVat ? `${currencySymbol} ${formatNumber(pdtVat)}` : "0.00"}
												</TableCell>
												<TableCell
													sx={{
														textAlign: "right",
														fontWeight: 500,
													}}
												>
													{`${currencySymbol} ${formatNumber(pdtTotal)}`}
												</TableCell>
											</TableRow>
										);
									})
								)}
							</TableBody>
							<TableFooter sx={{ 
								"& .MuiTableCell-root": {
									borderBottom: "none",
								}
							}}>
								<TableRow
									sx={{
										'& .MuiTableCell-root': {
											textAlign: "right",
											fontWeight: 500,
											fontSize: "0.75rem",
											py: 0.5,
											color: '#212b36',
											borderBottom: "none",
										}
									}}>
									<TableCell colSpan={5} align="right">
										Non VAT Goods
									</TableCell>
									<TableCell align="center">
										{currencySymbol} {totalzeroGoods || "0.00"}
									</TableCell>
								</TableRow>
								<TableRow
									sx={{
										'& .MuiTableCell-root': {
											textAlign: "right",
											fontWeight: 500,
											fontSize: "0.75rem",
											py: 0.5,
											color: '#212b36',
											borderBottom: "none",
										}
									}}>
									<TableCell colSpan={5} align="right">
										VAT Goods
									</TableCell>
									<TableCell align="center">
										{currencySymbol} {totalstd || "0.00"}
									</TableCell>
								</TableRow>
								<TableRow
									sx={{
										'& .MuiTableCell-root': {
											textAlign: "right",
											fontWeight: 500,
											fontSize: "0.75rem",
											py: 0.5,
											color: '#212b36',
											borderBottom: "none",
										}
									}}>
									<TableCell
										colSpan={5} align="right">
										{company_tax_type} Amount
									</TableCell>
									<TableCell align="center">
										{currencySymbol} {totalVal.grandTotalVat || "0.00"}
									</TableCell>
								</TableRow>
								<TableRow
									sx={{
										'& .MuiTableCell-root': {
											textAlign: "right",
											fontWeight: 600,
											color: '#212b36',
											fontSize: "0.8rem",
											py: 0.5,
											borderBottom: "none",
										}
									}}>
									<TableCell colSpan={5} align="right">
										Total Amount
									</TableCell>
									<TableCell align="center">
										{currencySymbol} {totalVal.grandTotal || "0.00"}
									</TableCell>
								</TableRow>
							</TableFooter>
						</Table>
					</TableContainer>
				</Paper>
			</Box>
		</>
	);

}
export default PurchaseViewPrint;
